import React from "react";
import { ShieldCheck } from "@phosphor-icons/react";

/**
 * Compact, reusable confidentiality + scope disclaimer.
 * Drop into any in-app flow where the leader is sharing sensitive context.
 *
 * Variants:
 *   - "inline" (default): subtle border + icon, sits in a content column
 *   - "compact": small grey text, no border (good under composers / forms)
 */
export default function Disclaimer({ variant = "inline", className = "" }) {
  if (variant === "compact") {
    return (
      <p
        data-testid="app-disclaimer"
        className={`text-xs text-[#8A948E] leading-relaxed ${className}`}
      >
        This service is for executive guidance only and is not a substitute for
        professional legal, HR, financial, medical, or psychological advice or
        therapy. Your conversations are private and are not accessible to the
        broader internet. To power AI responses, your messages are processed by
        Anthropic and OpenAI under their API data policies, which do not use
        customer data for model training.
      </p>
    );
  }
  return (
    <div
      data-testid="app-disclaimer"
      className={`bg-[#F3F0EA] border border-[#E8E4DB] rounded-xl px-4 py-3 flex items-start gap-3 text-xs text-[#4A524C] leading-relaxed ${className}`}
    >
      <ShieldCheck
        size={16}
        weight="duotone"
        className="text-[#1E3A2B] flex-shrink-0 mt-0.5"
      />
      <p>
        This service is for executive guidance only and is{" "}
        <strong className="text-[#1E3A2B]">
          not a substitute for professional legal, HR, financial, medical, or
          psychological advice or therapy
        </strong>
        . Your conversations are private and are not accessible to the broader
        internet. To power AI responses, your messages are processed by Anthropic
        and OpenAI under their API data policies, which do not use customer data
        for model training.
      </p>
    </div>
  );
}
